import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { TenantFeatureFlag, TenantFeatureFlagCreate, TenantFeatureFlagFilter } from '../data/tenantFeatureFlag';

export function createTenantFeatureFlagService(client: AxiosInstance) {
  return createCrudService<TenantFeatureFlag, TenantFeatureFlagCreate, TenantFeatureFlagFilter>(
    client,
    '/tenancy/TenantFeatureFlag',
    'id',
  );
}

export type TenantFeatureFlagService = CrudService<TenantFeatureFlag, TenantFeatureFlagCreate, TenantFeatureFlagFilter>;
